import { render, staticRenderFns } from "./AsterMail.vue?vue&type=template&id=fb6d33ec&"
import script from "./AsterMail.vue?vue&type=script&lang=js&"
export * from "./AsterMail.vue?vue&type=script&lang=js&"
import style0 from "./AsterMail.vue?vue&type=style&index=0&id=fb6d33ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports